<template>
	<div>
		<p>Мы используем cookie, чтобы улучшить ваше взаимодействие с сайтом</p>
		<UIShButton
			sm
			kind="secondary-gray"
			label="Ок, закрыть"
			@click="$emit('submit')"
		/>
	</div>
</template>

<script setup lang="ts">
const $emit = defineEmits<{
	(e: 'submit'): void;
}>();
</script>

<style lang="scss" scoped>
div {
	position: sticky;
	bottom: 0;
	width: 100%;
	padding: 0.889rem 0.667rem;
	border-top-left-radius: 1.111rem;
	border-top-right-radius: 1.111rem;
	background-color: var(--color-white);
	color: var(--color-gray950);
	@include useFont(tsms);
	z-index: var(--z-index-cookie);

	.btn {
		margin-top: 0.667rem;
	}
}

@include screen768 {
	div {
		display: grid;
		align-items: center;
		justify-self: end;
		grid-template-columns: 1fr auto;
		bottom: 1.111rem;
		margin-right: 1.111rem;
		column-gap: 0.667rem;
		width: 24.667rem;
		padding: 0.889rem;
		border-radius: 1.111rem;
	}
}
</style>
